import { ApolloQueryResult, useQuery } from '@apollo/client'

import { QueryHookOptions } from '@apollo/client/react/types/types'
import {
  getKatEvents,
  getKatEventsVariables,
} from '../../../../models/graphqlTypes'
import { GET_KAT_EVENTS } from '../../../../operations/treatmentOperations'
import { KatEvent } from '../types/treatments.types'

type Options = QueryHookOptions<getKatEvents, getKatEventsVariables>

type Return = {
  loading: boolean
  katEvents: KatEvent[] | undefined
  refetch: (
    variables?: Partial<getKatEventsVariables> | undefined
  ) => Promise<ApolloQueryResult<getKatEvents>>
}

export const useKatEvents = (options: Options = {}): Return => {
  const { data, loading, refetch } = useQuery<
    getKatEvents,
    getKatEventsVariables
  >(GET_KAT_EVENTS, options)

  const katEvents = data?.getKatEvents

  return {
    katEvents,
    loading,
    refetch,
  }
}
